(function () {
  'use strict';

  var STORAGE_KEY = 'ltp_consent_accepted';
  var MAX_WAIT_MS = 8000;
  var POLL_INTERVAL_MS = 100;

  function readMarker() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearMarker() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
    }
  }

  function publish(marker) {
    if (typeof window.segmentEventPublish !== 'function') return false;
    if (typeof window.OnetrustActiveGroups !== 'string') return false;
    try {
      window.segmentEventPublish({
        segmentType: 'track',
        trackName: 'LTP Consent Accepted',
        object: {
          locale: marker.locale || 'en',
          accepted_at: marker.ts || Date.now(),
          page: window.location.href,
        },
      });
      return true;
    } catch (e) {
      console.error('[LTP] telemetry publish failed:', e);
      return false;
    }
  }

  function start() {
    var marker = readMarker();
    if (!marker) return;

    var startedAt = Date.now();

    function attempt() {
      if (publish(marker)) {
        clearMarker();
        return;
      }
      if (Date.now() - startedAt > MAX_WAIT_MS) {
        return;
      }
      setTimeout(attempt, POLL_INTERVAL_MS);
    }

    attempt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
